import { EMPTY_IMAGE } from '../../../../../utils/images.constants';
import { OfflineImageCacheManager } from '../hooks/useQueryKeysAndFnToCache/utils/offlineImageCacheManager';

export const cacheStaticImages = async () => {
  const cache = await OfflineImageCacheManager.create();
  if (!cache) {
    return;
  }

  const images = [EMPTY_IMAGE];

  await Promise.all(
    images.map(async (image) => {
      const response = await fetch(image);
      await cache.cacheResponse(response.url, response.clone());
    }),
  );
};
